module.exports = __webpack_public_path__ + "static/media/56.822b54ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/56.svg
// module id = 161
// module chunks = 0